'use strict';

import 'lenis/dist/lenis.css';


import './iconfont/iconfont';

// import AOS from 'aos';
// import 'aos/dist/aos.css';

import { initScroll } from './modules/scroll';
import { initMenu } from './modules/menu';
import { initEmblaCarousel } from './modules/embla-carousel';
import { initForms } from './modules/forms';
// import { initGsap } from './modules/gsap';

import { checkAutoplaySupport, checkViewTransition, slideDown, slideUp } from './utils/feature';


const lenis = initScroll();


const langCode: string = document.documentElement.getAttribute('lang') || 'zh-CN';

document.addEventListener('DOMContentLoaded', async () => {

    // // 测试用≤
    const domLoop = document.querySelectorAll('[data-loop]');
    if (domLoop) {
        domLoop.forEach((item) => {
            const len: number = parseInt(item.getAttribute('data-loop')!);
            const sourceItem = item.innerHTML;
            for (let i = 0; i < len; i++) {
                // console.log(item.innerHTML);
                // item.appendChild(item.innerHTML);
                item.innerHTML += sourceItem;
            }
        });
    }

    const { lang } = await import(`./locales/${langCode}`);

    // const autoplaySupport = await checkAutoplaySupport({ muted: true });
    // console.log(autoplaySupport);
    initMenu(lenis);

    initEmblaCarousel();

    // here

    // 检测是否有 3D 桌子画布元素
    const tableCanvas = document.getElementById('tableCanvas');
    if (tableCanvas) {
        const { init3DTable } = await import('./modules/3d-table');
        init3DTable();
    }

    initForms(lang);

    // initGsap();

    // AOS.init({
    //     duration: 800,
    //     once: true,
    //     disable: window.innerWidth < 768 // 移动端禁用
    // });

    // Social Share - 懒加载
    // initSocialShare();


    const expandItems = document.querySelectorAll('.expand-item');
    if (expandItems.length) {
        expandItems.forEach((item) => {
            const btn = item.querySelector('.expand-item__header');
            const content = item.querySelector('.expand-item__body') as HTMLElement;
            btn?.addEventListener('click', () => {
                if (item.classList.contains('show')) {
                    item.classList.remove('show');
                    slideUp(content);
                } else {
                    item.classList.add('show');
                    slideDown(content);
                }
            });
        });
    }

});

// 社交分享（懒加载 + 事件委托）
// function initSocialShare() {
//     let ShareClass: typeof import('./plugins/simpleshare/index').default | null = null;
//     let shareInstance: InstanceType<typeof import('./plugins/simpleshare/index').default> | null = null;

//     document.addEventListener('click', async (e) => {
//         const target = (e.target as HTMLElement).closest('[data-share]');
//         if (!target) return;

//         e.preventDefault();

//         // 懒加载 SimpleShare 类
//         if (!ShareClass) {
//             ShareClass = (await import('./plugins/simpleshare/index')).default;
//         }

//         // 创建实例
//         if (!shareInstance) {
//             shareInstance = new ShareClass({
//                 url: window.location.href,
//                 title: document.title,
//                 content: document.querySelector('meta[name="description"]')?.getAttribute('content') || '',
//                 pic: document.querySelector('meta[property="og:image"]')?.getAttribute('content') || ''
//             });
//         }

//         shareInstance.goShare(target.getAttribute('data-share'));
//     });
// }
